/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';

import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';

import ComplementItem from '../ComplementItem';
import { formateBrPrice } from '../../../../utils/formateBrPrice';

import * as S from './styles';
import { IComplement } from '../../../../interfaces/IComplement';
import { ISelectedComplement } from '../ModalProduct';

interface ComplementProps {
  complement: IComplement;
  cartComplement?: ISelectedComplement | undefined;
  handleSelectedComplement: (cartComponent: ISelectedComplement) => void;
  selectedComplements: ISelectedComplement[];
  groupsUnderMinimum: { id: number; under: boolean }[];
  setGroupsUnderMinimum: (
    value: React.SetStateAction<
      {
        id: number;
        under: boolean;
      }[]
    >,
  ) => void;
}

const Complement: React.FC<ComplementProps> = (props) => {
  const {
    complement,
    cartComplement,
    handleSelectedComplement,
    selectedComplements,
    groupsUnderMinimum,
    setGroupsUnderMinimum,
  } = props;

  const [selectedQuantity, setSelectedQuantity] = useState(
    cartComplement?.quantity ?? 0,
  );
  const [full, setFull] = useState(false);
  const [selectedComponent, setSelectedComponent] = useState(
    cartComplement?.complement.id ?? +complement.minimumQuantity === 1
      ? String(cartComplement?.complement.id ?? complement.items[0].id)
      : '',
  );

  const handleRadioChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ): void => {
    const complemento = complement.items.find(
      (_complemento) =>
        Number((event.target as HTMLInputElement).value) === _complemento.id,
    );
    setSelectedComponent((event.target as HTMLInputElement).value);
    if (complemento !== undefined) {
      handleSelectedComplement({ complement: complemento, quantity: 1 });
    }
  };

  const handleClearRadioGroup = (value: string): void => {
    if (value === selectedComponent && +complement.minimumQuantity === 0) {
      setSelectedComponent('');

      const complemento = complement.items.find(
        (_complemento) => +value === _complemento.id,
      );
      if (complemento !== undefined) {
        handleSelectedComplement({ complement: complemento, quantity: 0 });
      }
    } else {
      const complemento = complement.items.find(
        (_complemento) => +value === _complemento.id,
      );
      if (complemento !== undefined) {
        handleSelectedComplement({ complement: complemento, quantity: 1 });
        setSelectedComponent(value);
      }
    }
  };

  useEffect(() => {
    if (
      +complement.minimumQuantity === 1 &&
      +complement.maximumQuantity === 1
    ) {
      if (complement.items[0] !== undefined) {
        handleSelectedComplement({
          complement: cartComplement?.complement ?? complement.items[0],
          quantity: cartComplement?.quantity ?? 1,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const temp = selectedComplements.filter(
      (item) => item.complement.complementId === complement.id,
    );

    if (temp.length > 0) {
      let tempQuantity = 0;

      temp.forEach((item) => {
        tempQuantity += +item.quantity;
      });

      setSelectedQuantity(tempQuantity);
    } else {
      setSelectedQuantity(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedComplements]);

  useEffect(() => {
    if (complement.maximumQuantity !== null) {
      if (selectedQuantity === +complement.maximumQuantity) {
        setFull(true);
      } else {
        setFull(false);
      }
    }

    if (complement.minimumQuantity !== null) {
      if (selectedQuantity < +complement.minimumQuantity) {
        setGroupsUnderMinimum((oldState) =>
          oldState.map((group) =>
            group.id === complement.id
              ? { id: complement.id, under: true }
              : group,
          ),
        );
      } else {
        setGroupsUnderMinimum((oldState) =>
          oldState.map((group) =>
            group.id === complement.id
              ? { id: complement.id, under: false }
              : group,
          ),
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedQuantity, `${groupsUnderMinimum.map((g) => g.id).join('-')}`]);

  return (
    <S.Container>
      <div className="header">
        <h3>{complement.name}</h3>
        {complement.maximumQuantity !== null &&
          (+complement.maximumQuantity !== 1 ||
            +complement.minimumQuantity !== 1) && (
            <S.Paragraph
              isError={selectedQuantity < +complement.minimumQuantity}
            >
              {+complement.minimumQuantity > 0
                ? `Escolhas ${selectedQuantity}/${+complement.maximumQuantity} - Mínimo ${+complement.minimumQuantity}`
                : `Escolhas ${selectedQuantity}/${+complement.maximumQuantity}`}
            </S.Paragraph>
          )}
      </div>
      {+complement.maximumQuantity !== 1 ? (
        <div>
          {complement.items
            .sort((a, b) => a.order - b.order)
            .map((item, index: number) => (
              <React.Fragment key={item.id}>
                <ComplementItem
                  handleSelectedComplement={handleSelectedComplement}
                  item={item}
                  full={full}
                  key={item.id}
                  cartComplement={
                    cartComplement?.complement.id === item.id
                      ? cartComplement
                      : null
                  }
                />
                <S.CustomDivider />
              </React.Fragment>
            ))}
        </div>
      ) : (
        <RadioGroup value={selectedComponent} onChange={handleRadioChange}>
          <div>
            {complement.items
              .sort((a, b) => a.order - b.order)
              .map((item, index: number) => (
                <React.Fragment key={item.id}>
                  <S.ComplementItem
                    onClick={() => handleClearRadioGroup(String(item.id))}
                  >
                    <div className="informations">
                      <p>{item.name}</p>
                      {+item.price.value !== 0 ? (
                        <p className="price">
                          {formateBrPrice(+item.price.value)}
                        </p>
                      ) : (
                        <></>
                      )}
                    </div>
                    <Radio value={String(item.id)} />
                  </S.ComplementItem>
                  <S.CustomDivider />
                </React.Fragment>
              ))}
          </div>
        </RadioGroup>
      )}
    </S.Container>
  );
};

export default Complement;
